import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { MapScreenshotPayload } from "../types/payloads";

const OpenScreenshotCommand: React.FC<AutomationCommandProps> = (props) => {
  const isMap = (props.command.payload as MapScreenshotPayload)?.scale;

  return <Container>Open {isMap ? "Map" : "Chart"} Screenshot</Container>;
};

export default OpenScreenshotCommand;

const Container = styled.div``;
